const moduleName = 'license_details';
export default moduleName;
